module.exports = __webpack_public_path__ + "static/media/renewal-renew-now-desktop.12e28008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/renewal-renew-now-desktop.jpg
// module id = 455
// module chunks = 0